import axios from "axios"

const config = {
    headers: {
        "Content-Type": "application/json",
        token: localStorage.jwtToken
    }
}

export const api = {
    updateUserTask: async (body) => {
        try {
            let response = await axios.post("https://admin.idexo.io/?path=task", body, config)
            return response.data
        } catch (error) {
            console.log(error)
            return null
        }
    },
    getUserTask: async () => {
        try {
            let response = await axios.get("https://leaderboard.idexo.io/?id=community_key", config)
            return response.data
        } catch (error) {
            console.log(error)
            return null
        }
    }
}
